import React, { Fragment, memo, useEffect, useState } from "react";


import {IconArrowNarrowRight, IconMapPinFilled} from "@tabler/icons-react"
import { useSelector } from "react-redux";
import { AppStore } from "../redux/store";
import axios from "axios";

const FooterComponent = memo(({mobileFirst}: any) => {
  const { country } = useSelector((store: AppStore) => store.country);
  const [contentFooter, setContentFooter] = useState<any>({})


  const GTFooter: string = '6gdUWDuA45IsiS51vOaUqp'
  const SVFooter: string = '7GbLQhQA2SC5KFo1YXp9Xs'

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://cdn.contentful.com/spaces/2s65zqhp8au5/entries/${ country === 'sv' ? SVFooter : GTFooter }`, {
          headers: {
            Authorization: 'Bearer y0IYxPnHITMQAbl3NERyBLUdvMzb8p3ON1tLtlDRna0'
          }
        });
        let data = response.data;
        setContentFooter(data?.fields)
      } catch (error) {
        console.error('Error al obtener datos:', error);
      }
    };
  
    fetchData();
  }, []);

    const adjustBreakpoint = (className: string) => {
    if (!mobileFirst) return className;
    
    return className
      .replace(/lg:/g, 'md:')
      .replace(/xl:/g, 'lg:')
      .replace(/2xl:/g, 'xl:');
  };

  
  return (
     <footer
          className={"block py-16 bg-[#2C2E2B] h-full"}
        >
          <div className="container mx-auto ">
            <div className={adjustBreakpoint("flex justify-between flex-col md:flex-row px-4 md:px-0")}>
              <div className={adjustBreakpoint("w-full lg:w-3/5 p-4 lg:p-6 text-sm")}>
                <div className="w-full">
                  <img
                    className="filter invert brightness-0 block md:m-0 mb-8 w-32" src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/propi_white.svg"
                    alt="Logo propi"
                  />
                </div>
                <p className="my-4 text-left text-white text-sm">
                  Somos una Proptech que busca democratizar el mercado de bienes
                  raíces, creando oportunidades para todos los participantes con
                  un servicio end-to-end a través de eficiencia y transparencia
                  para propietarios, inquilinos, agentes y desarrolladoras.
                </p>
                <a
                  href={`/${country}/quienes-somos`}
                  className="w-fit text-white text-left text-sm flex items-center justify-start ease-in-out duration-300 hover:translate-x-3"
                >
                  Conoce más <IconArrowNarrowRight color="#fff" />
                </a>
                <p className="flex justify-start items-center text-sm font-normal text-white mt-6">
                  <IconMapPinFilled color="#2FB672" />{" "}
                  {contentFooter?.contacto?.address_text}
                </p>
              </div>
              <div className={adjustBreakpoint("w-full mt-4 lg:mt-0 lg:w-1/5 md:px-4 md:pl-10 lg:text-left text-sm text-start px-4 lg:px-0")}>
                <h3 className="w-full text-white mb-4 font-semibold">
                  Navega en Propi
                </h3>

                {
                  !(country === "gt" || country === "pa") &&
                  <a href={`/${country}/bienes-raices/alquilar`}>

                    <div className="my-4 w-full duration-300 text-sm ease-in-out text-white hover:translate-x-3 cursor-pointer hover:text-primary">
                      Quiero alquilar
                    </div>
                  </a>
                }

                <a href={`/${country}/venta/casas-y-apartamentos/proyectos`}>
                  <div className="my-4 w-full duration-300 text-sm ease-in-out text-white hover:translate-x-3 cursor-pointer hover:text-primary">
                    Quiero comprar
                  </div>
                </a>
                {
                  !(country === "gt" || country === "pa") &&
                  <a href={`/${country}/alquiler/alquila-tu-casa-apartamento-con-propi`}>
                    <div className="my-4 w-full duration-300 text-sm ease-in-out text-white hover:translate-x-3 cursor-pointer hover:text-primary">
                      Quiero rentar mi propiedad
                    </div>
                  </a>
                }
                {
                  !(country === "gt" || country === "pa") &&
                  <a href={`/${country}/venta/vender-casa-apartamento-con-propi`}>
                    <div className="my-4 w-full duration-300 text-sm ease-in-out text-white hover:translate-x-3 cursor-pointer hover:text-primary">
                      Quiero vender mi propiedad
                    </div>
                  </a>
                }

                <a href={`/${country}/ayuda`}>
                  <div className="my-4 w-full duration-300 text-sm ease-in-out text-white hover:translate-x-3 cursor-pointer hover:text-primary">
                    Ayuda
                  </div>
                </a>
              </div>
              <div className={adjustBreakpoint("w-full lg:w-1/5 md:px-4 lg:text-left text-sm text-start px-4 lg:px-0")}>
                <h3 className="w-full text-white mb-4 font-semibold">
                  Sobre Propi
                </h3>
                <a href={`/${country}/quienes-somos`}>
                  <div className="my-4 w-full duration-300 text-sm ease-in-out text-white hover:translate-x-3 cursor-pointer hover:text-primary">
                    Quienes somos
                  </div>
                </a>
                <a href="https://blog.propilatam.com/" className="my-4 w-full duration-300 text-sm ease-in-out text-white hover:translate-x-3 cursor-pointer hover:text-primary block">
                  Blog de propi
                </a>
                <a href={`/app/${country}/politicas-privacidad`}>
                  <div className="my-4 w-full duration-300 text-sm ease-in-out text-white hover:translate-x-3 cursor-pointer hover:text-primary">
                    Políticas de privacidad
                  </div>
                </a>

                <a href={`/app/${country}/terminos-condiciones`}>
                  <div className="my-4 w-full duration-300 text-sm ease-in-out text-white hover:translate-x-3 cursor-pointer hover:text-primary">
                    Términos y condiciones
                  </div>
                </a>
              </div>
              <div className={adjustBreakpoint("w-full lg:w-1/5 md:px-4 lg:text-left text-sm text-start px-4 lg:px-0")}>
                <h3 className="w-full text-white mb-4 font-semibold">
                  Trabaja con Propi
                </h3>
                <a href={`/app/${country}/referidos`} className="my-4 w-full duration-300 text-sm ease-in-out text-white hover:translate-x-3 cursor-pointer hover:text-primary block">
                  Refiere y gana
                </a>
              </div>
            </div>
          </div>
          <hr className="border-primary mt-2 mb-1 py-4 lg:py-0" />
          <div className={adjustBreakpoint("flex justify-between flex-col md:flex-row px-4 md:px-0 container mx-auto")}>
            <div className={adjustBreakpoint("w-full lg:w-3/5 p-0 lg:p-6 text-sm")}>
              <h3 className="w-full text-white mb-4 font-semibold text-start">
                Respaldados por
              </h3>
              {
                country === "sv" && <div className={adjustBreakpoint("grid grid-cols-4 lg:grid-cols-6 gap-4 place-items-center")}>
                  {
                    contentFooter?.propiPartners?.filter((item: any) => item?.name !== "Casalco")
                      .map((item: any, index: number) => (
                        <Fragment key={index}>
                          <img className="filter invert brightness-0" src={item?.url} alt={item?.alt} />
                        </Fragment>
                      ))
                  }
                  {
                    contentFooter?.propiPartners?.some((item: any) => item?.name === "Casalco") && (
                      <img className="w-10 filter invert brightness-0" src={contentFooter?.propiPartners.find((item: any) => item?.name === "Casalco")?.url} alt="Casalco" />
                    )
                  }
                </div>
              }

              {
                country === "gt" && <div className={adjustBreakpoint("grid grid-cols-4 lg:grid-cols-6 gap-4 place-items-center")}>
                  {
                    contentFooter?.propiPartners?.filter(
                      (item: any) => !["Casalco", "FHA", "CBR", "ADIG"].includes(item?.name)
                    ).map((item: any, index: number) => (
                      <Fragment key={index}>
                        <img src={item?.url} alt={item?.alt} className="filter invert brightness-0" />
                      </Fragment>
                    ))
                  }

                  {
                    ["Casalco", "FHA", "CBR", "ADIG"].map((name) => {
                      const partner = contentFooter?.propiPartners?.find((item: any) => item?.name === name);
                      return partner ? (
                        <img key={name} className=" w-20 filter invert brightness-0" src={partner.url} alt={partner.alt} />
                      ) : null;
                    })
                  }

                </div>
              }

            </div>
            <div className={adjustBreakpoint("w-full mt-6 lg:w-1/5 md:px-4 md:pl-10 lg:text-left text-sm")}>
              <h3 className="w-full text-white mb-4 font-semibold  text-start">
                Métodos de pago
              </h3>
              <div className={adjustBreakpoint(`flex lg:grid ${country === "sv" ? 'grid-cols-3' : 'grid-cols-2'} gap-2 place-items-start items-center`)}>
                <img className="filter invert brightness-0" src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/footer/visa.svg" alt="" />
                <img className="filter invert brightness-0" src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/footer/mastercard.svg" alt="" />
                {
                  country === "sv" && <Fragment>
                    {
                      contentFooter?.logos && contentFooter?.logos?.map((item: any, index: number) => (
                        <img key={index} className="w-8 filter invert brightness-0" src={item?.url} alt={item?.alt} />
                      ))
                    }
                  </Fragment>
                }

              </div>
            </div>
            <div className={adjustBreakpoint("w-full mt-6 lg:w-1/5 md:px-4 md:pl-10 lg:text-left text-sm")}>
              <h3 className="w-full text-white mb-4 font-semibold  text-start">
                Síguenos
              </h3>
              <div className={adjustBreakpoint("flex justify-start lg:justify-between items-center gap-3")}>
                <a href=" https://www.facebook.com/propi.latam/" target="_blank">
                  <img className="filter invert brightness-0" src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/footer/facebook.svg" alt="" />
                </a>
                <a href="https://www.instagram.com/propi.latam/" target="_blank" rel="noreferrer">
                  <img className="filter invert brightness-0" src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/footer/instagram.svg" alt="" />
                </a>
                <a href="https://www.linkedin.com/company/propilatam" target="_blank" rel="noreferrer">
                  <img className="filter invert brightness-0" src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/footer/linkedin.svg" alt="" />
                </a>
                <a href="#">
                  <img className="filter invert brightness-0" src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/footer/whatsapp.svg" alt="" />
                </a>
              </div>
            </div>
            <div className={adjustBreakpoint("w-full lg:w-1/5 md:px-4")} />
          </div>
        </footer>
  );
});
FooterComponent.displayName = "FooterComponent";
export default FooterComponent;
